import Vue from 'vue'
import dateFormatter from "@/components/formatter/dateFormatter";

Vue.filter('date', function (value) {
  return dateFormatter(value);
})
